module.exports = __webpack_public_path__ + "img/arrow-up.38ef2e46.svg";